import styles from './ProfileAvatar.module.css';
import AuthService from '../../../../../services/AuthService';
import AvatarIcon from '../AvatarIcon/AvatarIcon';
import { useTranslation } from 'react-i18next';
const ProfileAvatar = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <AvatarIcon width={40} height={40} />
      <div>
        <div className={styles.name}>{AuthService.getFirstName()}</div>
        <div className={styles.role}>{t('headerProfile.user')}</div>
      </div>
    </div>
  );
};

export default ProfileAvatar;
